import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from 'containers/App';
import {
  Route,
  BrowserRouter,
  Routes,
} from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { ConfigProvider } from 'config/ConfigProvider';
import { restoreTrustedDevice } from 'utils/deviceKeyStorage';
import FindCustomerPage from './containers/FindCustomerPortal';
import ScrollToTop from './components/ScrollToTop';
import configureStore from './store';
import { unregister } from './registerServiceWorker';

import './assets/styles/global.scss';

restoreTrustedDevice();

const initialState = {};
const storeConfig = configureStore(initialState);

const renderApp = () => {
  createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <ConfigProvider>
        <Provider store={storeConfig.store}>
          <PersistGate loading={null} persistor={storeConfig.persistor}>
            <BrowserRouter>
              <Routes>
                <Route path="/container" element={<FindCustomerPage />} />
                <Route
                  path="/*"
                  element={(
                    <ScrollToTop>
                      <App />
                    </ScrollToTop>
                  )}
                />
              </Routes>
            </BrowserRouter>
          </PersistGate>
        </Provider>
      </ConfigProvider>
    </React.StrictMode>
  );
};

setTimeout(renderApp, 300);

unregister();
